import React from 'react'
import { Link } from "react-router-dom";

function Joinm() {
  return (
    <div> 
        <div className="album py-2">
      <div className="container">
        <h2>Membership Plan of <b>MISAA</b></h2>
      </div>
    </div>

    
          <div className="album py-0">
            <div className="container">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <div className='lifemember'>
                    <div className="card-body">
                      <center>
                        <br />
                        <h3 style={{ color: "white" }} className=''><b>LIFETIME MEMBERSHIP</b></h3>
                      </center>
                    </div>
                  </div>
                  <div className='background2'>
                    <br />
                     <center>
                     
                    <h5>Enroll for lifetime membership</h5>
                    <a href='Lifetime'>
                    <button className='lifetimeM'>Lifetime & View Details <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="eveno
  dd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>
</a>

                    </center>
                    <br/>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <div className='lifemembers'>
                    <div className="card-body">
                      <center>
                        <br />
                        <h3 style={{ color: "white" }} className=''><b>GENERAL MEMBERSHIP</b></h3>
                      </center>
                    </div>
                  </div>
                  <div className='background2'>
                    <br />
                    <center>
                     
                    <h5>Enroll for general membership</h5>
                    <a href='Yearly_member'>
                    <button className='yearlybutton'>Yearly & View Details <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>
</a>
                    </center>
                    <br/>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <br/>
          <br/>
    </div>
  )
}

export default Joinm